(() => {
  const key = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
  if (!customElements.get('gf-accessory-slider')) customElements.define('gf-accessory-slider', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-accessory-track]');
      this.controls = this.querySelector('[data-accessory-controls]');
      if (!this.track) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-accessory-prev],[data-accessory-next],[data-slide-index]');
        if (!button || !this.controls?.contains(button)) return;
        const index = button.hasAttribute('data-slide-index') ? Number(button.dataset.slideIndex) : this.current() + (button.hasAttribute('data-accessory-prev') ? -1 : 1);
        const pages = this.navigationSlides();
        const slide = pages[Math.max(0, Math.min(index, pages.length - 1))];
        if (slide) this.track.scrollBy({left: slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: motion()});
      }, {signal});
      this.track.addEventListener('scroll', () => this.sync(), {signal, passive: true});
      this.resize = new ResizeObserver(() => this.refresh());
      this.resize.observe(this.track);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, event => {
        if (String(event.data?.sectionId) === this.dataset.section) this.matchModel(event.data.variant?.options?.[0]);
      });
      const picker = this.closest('product-info')?.querySelector('variant-selects select');
      const selected = picker?.selectedOptions?.[0];
      this.matchModel(selected?.textContent || this.dataset.referenceModel);
      this.refresh();
    }
    matchModel(model) {
      if (!model) return;
      this.querySelectorAll('[data-screen-protector]').forEach(row => {
        const select = row.querySelector('select[name="id"]');
        if (!select) return;
        const match = [...select.options].find(option => key(option.dataset.model || option.textContent) === key(model) && !option.disabled);
        const slide = row.closest('[data-accessory-slide]');
        slide.hidden = !match;
        if (match) { select.value = match.value; select.dispatchEvent(new Event('change', {bubbles: true})); }
      });
      this.refresh();
    }
    navigationSlides() {
      const stacked = this.closest('gf-wallet-recommendations') && matchMedia('(max-width: 749px)').matches;
      return stacked ? (this.slides || []).filter((slide, index) => index % 2 === 0) : (this.slides || []);
    }
    current() {
      if (!this.slides?.length) return 0;
      const left = this.track.getBoundingClientRect().left;
      const pages = this.navigationSlides();
      return pages.reduce((best, slide, i) => Math.abs(slide.getBoundingClientRect().left - left) < Math.abs(pages[best].getBoundingClientRect().left - left) ? i : best, 0);
    }
    refresh() {
      this.slides = [...this.track.querySelectorAll(':scope > [data-accessory-slide]')].filter(slide => !slide.hidden);
      const dots = this.controls?.querySelector('[data-accessory-dots]');
      const pages = this.navigationSlides();
      if (dots && dots.children.length !== pages.length) {
        dots.replaceChildren(...pages.map((slide, index) => {
          const button = document.createElement('button'); button.type = 'button'; button.dataset.slideIndex = index;
          button.setAttribute('aria-label', slide.querySelector('h3')?.textContent || String(index + 1)); return button;
        }));
      }
      if (this.controls) this.controls.hidden = this.slides.length < 2 || this.track.scrollWidth <= this.track.clientWidth + 2;
      this.sync();
    }
    sync() {
      const index = this.current();
      this.controls?.querySelectorAll('[data-slide-index]').forEach((button, i) => button.setAttribute('aria-current', String(i === index)));
      const prev = this.controls?.querySelector('[data-accessory-prev]'), next = this.controls?.querySelector('[data-accessory-next]');
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = !this.slides?.length || this.slides.at(-1).getBoundingClientRect().right <= this.track.getBoundingClientRect().right + 2;
    }
    disconnectedCallback() { this.abort?.abort(); this.resize?.disconnect(); this.unsubscribe?.(); }
  });
  if (!customElements.get('gf-wallet-recommendations')) customElements.define('gf-wallet-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute('data-artwork-recommendations')) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.abort = new AbortController();
      this.wallets = [JSON.parse(this.querySelector('[data-initial-wallet]').textContent)];
      this.baseCard = this.querySelector('[data-wallet-slide] .gf-pairs__row').cloneNode(true);
      this.selectedId = this.wallets[0].id;
      this.dialog.classList.add('gf24-wallet-dialog');
      document.body.append(this.dialog);
      const onClick = event => {
        if (event.target.closest('[data-wallet-open]')) {
          event.preventDefault(); event.stopPropagation();
          this.opener = event.target.closest('button'); this.renderPicker(); this.openPicker(); this.load();
        }
        if (event.target.closest('[data-wallet-close]')) this.dialog.close();
        if (event.target.closest('[data-wallet-retry]')) this.load();
        const choice = event.target.closest('[data-wallet-id]');
        if (choice) { this.choose(this.wallets.find(wallet => String(wallet.id) === choice.dataset.walletId)); this.dialog.close(); }
        if (event.target === this.dialog) { const r = this.dialog.getBoundingClientRect(); if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dialog.close(); }
      };
      this.addEventListener('click', onClick, {signal: this.abort.signal});
      this.dialog.addEventListener('click', onClick, {signal: this.abort.signal});
      this.dialog.addEventListener('close', () => {
        this.unlockPage();
        if (this.opener?.isConnected) this.opener.focus({preventScroll:true});
      }, {signal: this.abort.signal});
      this.load();
    }
    openPicker() {
      if (this.dialog.open) return;
      const body = document.body;
      const properties = ['position','top','left','right','overflow','paddingRight','boxSizing'];
      this.pageLock = {x:window.scrollX,y:window.scrollY,styles:Object.fromEntries(properties.map(name => [name,body.style[name]]))};
      const gutter = Math.max(0,window.innerWidth - document.documentElement.clientWidth);
      const padding = parseFloat(getComputedStyle(body).paddingRight) || 0;
      Object.assign(body.style,{position:'fixed',top:`-${this.pageLock.y}px`,left:'0',right:'0',overflow:'hidden',paddingRight:`${padding + gutter}px`,boxSizing:'border-box'});
      try { this.dialog.showModal(); }
      catch (error) { this.unlockPage(); throw error; }
    }
    unlockPage() {
      if (!this.pageLock) return;
      const saved = this.pageLock; this.pageLock = null;
      Object.assign(document.body.style,saved.styles);
      window.scrollTo({left:saved.x,top:saved.y,behavior:'instant'});
    }
    async load() {
      if (this.loading || this.loaded) return;
      this.loading = true;
      const status = this.dialog.querySelector('[data-wallet-status]'), retry = this.dialog.querySelector('[data-wallet-retry]');
      status.textContent = ''; retry.hidden = true;
      try {
        let url = new URL(this.dataset.source, location.origin); url.searchParams.set('view', 'gf-wallet-source');
        const products = [], visited = new Set();
        while (url) {
          if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid collection pagination');
          visited.add(url.href);
          const response = await fetch(url, {signal: this.abort.signal});
          if (!response.ok) throw new Error('Collection unavailable');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const data = JSON.parse(doc.querySelector('[data-wallet-source]').textContent);
          products.push(...data.products.filter(product => product.variants.some(variant => variant.available)));
          url = data.next ? new URL(data.next, location.origin) : null;
          if (url) url.searchParams.set('view', 'gf-wallet-source');
        }
        this.wallets = [...new Map(products.map(product => [product.id, product])).values()];
        if (!this.wallets.length) this.wallets = [JSON.parse(this.querySelector('[data-initial-wallet]').textContent)];
        this.loaded = true;
        if (!this.userSelected) {
          const matched = this.wallets.find(wallet => key(wallet.title.replace(/\s+(?:magsafe|magnetic).*$/i, '')) === key(this.dataset.artwork));
          this.choose(matched || this.wallets[Math.floor(Math.random() * this.wallets.length)], false);
        }
        this.renderPicker();
      } catch (error) {
        if (error.name !== 'AbortError') { status.textContent = this.dataset.walletError; retry.hidden = false; }
      } finally { this.loading = false; }
    }
    choose(wallet, user = true) {
      if (!wallet) return;
      if (user) this.userSelected = true;
      this.selectedId = wallet.id;
      const card = this.baseCard.cloneNode(true), title = card.querySelector('[data-accessory-title]');
      title.textContent = card.hasAttribute('data-compact-accessory') ? wallet.title.replace(/\s+(?:magsafe|magnetic).*$/i, '') : wallet.title;
      title.title = wallet.title; title.setAttribute('aria-label', wallet.title);
      const subtitle = card.querySelector('[data-accessory-subtitle]');
      if (subtitle) subtitle.textContent = this.dataset.walletSubtitle || '';
      const img = card.querySelector('img');
      if (img && wallet.image) { img.src = wallet.image; img.removeAttribute('srcset'); img.alt = wallet.title; }
      else if (img) img.remove();
      const form = card.querySelector('form'), field = form.querySelector('[name="id"]');
      const available = wallet.variants.filter(variant => variant.available), variant = available[0];
      const input = document.createElement('input'); input.type = 'hidden'; input.name = 'id'; input.value = variant.id;
      field.replaceWith(input);
      const price = card.querySelector('[data-gf-accessory-price]');
      const current = price.querySelector('[data-accessory-current]'), compare = price.querySelector('[data-accessory-compare]');
      if (current) current.textContent = variant.price; else price.textContent = variant.price;
      if (compare) { compare.textContent = variant.comparePrice || ''; compare.hidden = !variant.comparePrice; }
      card.querySelector('button[type="submit"]').setAttribute('aria-label', wallet.title);
      card.querySelector('button[type="submit"]').disabled = false;
      this.querySelector('[data-wallet-slide] .gf-pairs__row').replaceWith(card);
      this.querySelector('gf-accessory-slider')?.refresh();
    }
    renderPicker() {
      const grid = this.dialog.querySelector('[data-wallet-grid]');
      grid.replaceChildren(...this.wallets.map(wallet => {
        const button = document.createElement('button'); button.type = 'button'; button.dataset.walletId = wallet.id;
        button.setAttribute('aria-pressed', String(wallet.id === this.selectedId));
        const img = document.createElement('img'); img.src = wallet.image; img.alt = ''; img.loading = 'lazy'; img.width = 160; img.height = 160;
        const title = document.createElement('span'); title.textContent = wallet.title;
        const price = document.createElement('span'); price.textContent = wallet.variants.find(variant => variant.available).price;
        button.append(img, title, price); return button;
      }));
    }
    disconnectedCallback() { if (this.dialog?.open) this.dialog.close(); this.unlockPage(); this.abort?.abort(); this.dialog?.remove(); }
  });
})();
